module.exports = __webpack_public_path__ + "img/defaultImg.4f3ea68d.svg";